// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nsvg[data-v-79153139] {\n    display: flex;\n    vertical-align: baseline;\n    margin: auto;\n}\n#_288[data-v-79153139] {\n    fill: rgba(255,255,255,1);\n    width: 100%;\n    height: 100%;\n}\n._288[data-v-79153139] {\n    width: 17.2px;\n    height: 15px;\n}\n\n", ""]);
// Exports
module.exports = exports;
